import { render } from "./letter-compose-step4.vue?vue&type=template&id=13f1d4bc"
import script from "./letter-compose-step4.vue?vue&type=script&lang=js"
export * from "./letter-compose-step4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__